import { deviceEnquire, DEVICE_TYPE } from '@/utils/device'
import { mapState } from 'vuex'
// mixin 定义的函数或变量，必须以  $xx开头 ，xx 代表使用的所属mixin缩写，避免命名空间污染
const mixinDevice = {
  computed: {
    ...mapState({
      device$d: state => state.app.device,
    }),
  },
  methods: {
    isMobile$d() {
      return this.device === DEVICE_TYPE.MOBILE
    },
    isDesktop$d() {
      return this.device === DEVICE_TYPE.DESKTOP
    },
    isTablet$d() {
      return this.device === DEVICE_TYPE.TABLET
    },
  },
}

const AppDeviceEnquire = {
  mounted() {
    const { $store } = this
    deviceEnquire(deviceType => {
      switch (deviceType) {
        case DEVICE_TYPE.DESKTOP:
          $store.commit('TOGGLE_DEVICE', 'desktop')
          break

        case DEVICE_TYPE.LAPTOP:
          $store.commit('TOGGLE_DEVICE', 'laptop')
          break

        case DEVICE_TYPE.TABLET:
          $store.commit('TOGGLE_DEVICE', 'tablet')
          break

        case DEVICE_TYPE.MOBILE:
        default:
          $store.commit('TOGGLE_DEVICE', 'mobile')
          break
      }
    })
  },
}
// 虽然很方便，但是谨慎用，清楚使用时机！最重要的原则，尽量不在mixin中定义变量
const queryViewMixin = {
  /**
   *  使用这个queryView 必须定义的东西
   *  data:{ form, pageNumber, pageSize }
   * */
  computed: {
    modalFormLayout$qv() {
      return {
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 18,
        },
      }
    },
  },
  methods: {
    // 安全的设置form包含的fields(设置不包含的fileds会导致警告)
    handleTableChange$qv(pagination, filters, sorter) {
      const columnIndex = this.tableColumns.findIndex(column => {
        // 要排序的项必须设置dataIndex
        return column.dataIndex === sorter.columnKey
      })
      this.tableColumns.map((column, index) => {
        if (index === columnIndex) {
          column.sortOrder = sorter.order
        } else {
          column.sortOrder = false
        }
      })
      const { current, pageSize } = pagination
      this.pageSize = pageSize
      this.pageNumber = current
      this.doQuery()
    },
    getSortParams$qv() {
      const sortColumn = this.tableColumns.find(column => column.sortOrder)
      let sortField = ''
      let sortOrder = ''
      if (sortColumn) {
        sortField = sortColumn.dataIndex
        sortOrder = sortColumn.sortOrder || ''
      }
      return {
        sortField,
        sortOrder,
      }
    },
    // 默认会转换moment 为YYYY-MM-DD （可以不使用这个，在doQuery中自行组装参数）
    getPageParams$qv(pageNumber, pageSize, extend = {}) {
      const params = this.form.getFieldsValue()
      const sortParams = this.getSortParams$qv()
      return {
        pageNumber,
        pageSize,
        data: {
          ...params,
          ...sortParams,
          ...extend,
        },
      }
    },
    getPageParams$qvt(pageNumber, pageSize, extend = {}) {
      const params = this.form.getFieldsValue()
      return {
        page: pageNumber,
        limit: pageSize,
          ...params,
          ...extend,
      }
    },
    // 主函数
    doQuery() {
      console.warn('should implement')
    },
    resetAndQuery$qv() {
      this.resetForm$qv(this.form)
      this.doQuery(1)
    },
    resetForm$qv(form) {
      form.resetFields()
    },
    resetTable$qv() {
      this.pageNumber = 1
      this.countTotal = 0
      this.dataSource = []
    },

    getSelectedRowKeys$qv() {
      if (!this.selectedRowKeys.length) {
        this.$error({ title: '请选择要操作的行' })
        return Promise.reject(new Error('E_NO_SELECT'))
      } else {
        return this.selectedRowKeys
      }
    },
    checkBatchActionRows$qv(rows = this.selectedRows) {
      if (!rows.length) {
        this.$error({ title: '请选择要操作的行' })
        return Promise.reject(new Error('E_NO_SELECT'))
      } else {
        return rows
      }
    },
  },
}
const toolMixin = {
  methods: {
    // 会标准化 null 或者 '' 为undefined
    safeSetFieldsValue$t(form, data, { emptyAsUndefined = true } = {}) {
      this.$nextTick(() => {
        const fields = form.getFieldsValue()
        let initData = {}
        for (let i in fields) {
          if (i in data) {
            let formItem = data[i]
            if (emptyAsUndefined) {
              if (formItem === null || formItem === '') {
                formItem = undefined
              }
            }
            initData[i] = formItem
          }
        }
        form.setFieldsValue(initData)
        for (const i in form.instances) {
          let f = form.instances[i]
          if (f.$options._componentTag === 'PictureCardListUpload') {
            // f.resetFileList()
          }
        }
      })
    },
    translateType$t(value, typeName, typesMap = this.typesMap || {}) {
      let label = ''
      try {
        const mapIncludesCollection = {}
        const collectionMap = this.$store.state.collectionStore.collectionMap
        for (const i in collectionMap) {
          mapIncludesCollection[i] = collectionMap[i].list
        }
        for (const i in typesMap) {
          mapIncludesCollection[i] = typesMap[i]
        }
        const type = mapIncludesCollection[typeName]?.find(v => String(v.value) === String(value))
        if (type) {
          label = type.label
        }
      } catch (e) {
        console.error(e)
      }
      return label
    },
    formatParams$t(
      params,
      generateNewKeyValue = (key, value) => {
        return { key, value }
      }
    ) {
      let result = {}
      for (let i in params) {
        const kvs = generateNewKeyValue({ key: i, value: params[i] })
        let kvArray = []
        if (kvs instanceof Array) {
          kvArray = kvs
        } else {
          kvArray = [kvs]
        }
        kvArray.map(kv => {
          if (kv && kv && 'key' in kv && 'value' in kv) {
            result[kv.key] = kv.value
          }
        })
      }
      return result
    },
    formatTimeRangeParams$t(params, keys, format = 'YYYY-MM-DD HH:mm:ss') {
      let keyArr = []

      if (typeof keys === 'string') {
        keyArr = [keys]
      } else {
        keyArr = keys
      }
      return this.formatParams$t(params, ({ key, value }) => {
        if (keyArr.includes(key)) {
          if (value) {
            const Upper1stChar = key.charAt(0).toUpperCase() + key.slice(1)
            const rangeStart = {
              key: `start${Upper1stChar}`,
              value: value[0] ? value[0].startOf('day').format(format) : '',
            }
            const rangeEnd = {
              key: `end${Upper1stChar}`,
              value: value[1] ? value[1].endOf('day').format(format) : '',
            }
            return [rangeStart, rangeEnd]
          }
        }
        return { key, value }
      })
    },
    filterByPY$t(input, option) {
      const label = option.componentOptions.children[0].text
      const labelFirstLetter = window.pinyinUtil.getFirstLetter(label, true)
      if (label.toUpperCase().includes(input.toUpperCase())) {
        return true
      }
      for (let i = 0; i < labelFirstLetter.length; i++) {
        if (labelFirstLetter[i].includes(input.toUpperCase())) {
          return true
        }
      }
      return false
    },
    reset$t(rootDataFieldName) {
      if (rootDataFieldName) {
        this[rootDataFieldName] = this.$options.data.call(this)[rootDataFieldName]
      } else {
        Object.assign(this.$data, this.$options.data.call(this))
      }
    },
    resetModal$t(modalName = 'modal') {
      this.reset$t(modalName)
    },
    useRowIndex(row, index) {
      return index
    },
  },
  filters: {
    text(value) {
      return value.replace(/<\/?.+?\/?>/g, '')
    },
  },
}
export { AppDeviceEnquire, mixinDevice, queryViewMixin, toolMixin }
